import { IDayPartBoundary } from 'state/menu/main-menu/types';

/**
 * Returns the day-part list only when it is a usable source. An empty result is not authoritative
 * (a store can have configured hours with none active now), so callers treat it as omitted and
 * fall back to their payload/legacy source.
 */
export const normalizeAvailableDayParts = (
  availableDayParts: IDayPartBoundary[] | undefined
): IDayPartBoundary[] | undefined =>
  availableDayParts && availableDayParts.length > 0 ? availableDayParts : undefined;
